import api from '../../api'
import moment from 'moment'
import {
    SET_MARKETSTUDY_MATCHED_ADS
} from '../../constants'

const default_state = {
    matched_ads: [{'id': 'default', 'adopted_area': 0, 'offer_price': 0, 'offer_unit_price': 0}]
}
const state = default_state

function chunk (str, n) {
    let ret = []
    let i
    let len

    for (i = 0, len = str.length; i < len; i += n) {
        ret.push(str.substr(i, n))
    }

    return ret
}

//This function takes in latitude and longitude of two location and returns the distance between them (in km)
function calcDistance (lat1, lng1, lat2, lng2) {
    // console.log('yeah calc dist')
    let R = 6371 // km
    let dLat = toRad(lat2 - lat1)
    let dLng = toRad(lng2 - lng1)
    lat1 = toRad(lat1)
    lat2 = toRad(lat2)

    let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(lat1) * Math.cos(lat2)
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    let d = R * c
    return d
}

// Converts numeric degrees to radians
function toRad (Value) {
    return Value * Math.PI / 180
}

function collect_ad_locations (object, result) {
    _.forEach(object, function (value, key) {
        // console.log('value: ')
        // console.log(value)
        if (_.isObject(value)) {
            collect_ad_locations(value, result)
        } else {
            result.push(key)
        }
    })
}

let temp_i = 0

function collect_ads (ref_lat, ref_lng, ref_startdate, ref_limitdate, radius_km, object, result) {
    _.forEach(object, function (value, key) {
        // console.log('value: ')
        // console.log(value)


        if (_.isObject(value)) {

            if(value['ad_address']){
                console.log('-->  ' + value['ad_address'])
            }else{
                console.log('--> there is no value or no ad_address')
            }

            if (value['offer_price']) {
                // console.log('pushing value....')
                // console.log(value)
                /*temp_i = temp_i + 1
                 value['temp_id'] = temp_i.toString()*/

                if (moment(value['ad_date']).isSameOrAfter(ref_startdate)) {

                    if (moment(value['ad_date']).isSameOrBefore(ref_limitdate)) {

                        let distance = calcDistance(ref_lat, ref_lng, value['lat'], value['lng']).toFixed(3)

                        if (distance <= radius_km) {
                            value['distance'] = distance
                            result.push(value)
                        }else{
                            console.log('distance is higher than radius_km')
                        }

                    }else{
                        console.log('ad_date is not same or before ref_limitdate')
                    }

                }else{
                    console.log('ad_date is not same or after ref_startdate')
                }

            } else {
                console.log('there is no value or no offer_price')
                collect_ads(ref_lat, ref_lng, ref_startdate, ref_limitdate, radius_km, value, result)
            }
        } else {
             console.log('item is not an object?? key: ')
            console.log(key)
            // console.log('*** not an object?? value: ')
            // console.log(value)

            /*
            if (key !== 0) {
                result.push(key)
            }
            */
        }
    })
}

const actions = {
    FETCH_MARKETSTUDY_MATCHED_ADS: ({state, commit, rootState}, data) => {

        // console.log('data.path (fetch_marketstudy_matched_ads) ---->')
        // console.log(data.path)
        return api.get({path: data.path})
            .then((res) => {
                console.log(res)
                commit(SET_MARKETSTUDY_MATCHED_ADS, res)
            })
    },
    QUERY_ADS: ({state, commit, rootState}, data) => {

        let result = []
        return new Promise((resolve, reject) => {
            const reference_geohash = data.geohash

            console.log('Query ads data: ')
            console.log(data)
            console.log('reference_geohash: ')
            console.log(reference_geohash)

            // console.log('data.precision: ')
            // console.log(data.precision)

            let precision = 6

            /*
            if (data.radius_km < 0.6) {
                precision = 6
            } else if (data.radius_km < 3.8) {
                precision = 5
            } else if (data.radius_km < 19) {
                precision = 3
            }
            */

            if (data.radius_km < 0.6) {
                precision = 5
            } else if (data.radius_km < 3.8) {
                precision = 4
            } else if (data.radius_km < 19) {
                precision = 3
            }

            /*
            else{
                precision = 2
            }
            */

            const query_geohash = reference_geohash.substring(0, precision)

            // console.log('query_geohash:')
            // console.log(query_geohash)

            let ad_year_start = data.startdate

            let ad_year_limit = data.limitdate

            ad_year_start = ad_year_start.substring(0, 4)

            ad_year_limit = ad_year_limit.substring(0, 4)

            const query_path_start = 'ads' + '/' + data.ad_type + '/' + ad_year_start + '/' + chunk(query_geohash, 1).join('/')

            console.log('query_path_start: ')
            console.log(query_path_start)

            const query_path_limit = 'ads' + '/' + data.ad_type + '/' + ad_year_limit + '/' + chunk(query_geohash, 1).join('/')

            console.log('query_path_limit: ')
            console.log(query_path_limit)

            let average_price = 0
            // let top_listed = []
            let markers = []
            let map_url = 'https://maps.googleapis.com/maps/api/staticmap?' +
                'center=' + data.lat + ',' + data.lng +
                '&zoom=' + '16' +
                '&size=' + '640x480' +
                '&maptype=' + 'roadmap' +
                '&markers=color:red%7Clabel:%7C' + data.lat + ',' + data.lng +
                '&style=' + 'feature:poi|element:labels|visibility:off' +
                '&format=' + 'png' +
                '&visual_refresh=' + 'true' +
                '&key=' + 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k'

            let sorted_result_start = []
            let sorted_result_limit = []

            const calcSum = function (array) {
                let num = 0
                for (let i = 0, l = array.length; i < l; i++) num += array[i]
                return num
            }

            const calcMean = function (array) {
                return calcSum(array) / array.length
            }

            const set_markers = function(sorted_result){

                // we take 'offer_unit_price', not the 'estimated_unitsale_price'
                let unit_prices = _.map(sorted_result, 'offer_unit_price')
                let lats = _.map(sorted_result, 'lat')
                let lngs = _.map(sorted_result, 'lng')
                let urls = _.map(sorted_result, 'url')
                let addresses = _.map(sorted_result, 'google_formatted_address')

                let max_ads = 25

                if (unit_prices.length > max_ads) {
                    // we get the first 30 elements only (the closest ones)
                    unit_prices = unit_prices.slice(0, max_ads)
                    lats = lats.slice(0, max_ads)
                    lngs = lngs.slice(0, max_ads)
                    urls = urls.slice(0, max_ads)
                    addresses = addresses.slice(0, max_ads)
                }

                for (let i = 0; i < unit_prices.length; i++) {

                    // var chr = String.fromCharCode(97 + n); // where n is 0, 1, 2 ...
                    //  Note that if n > 25, you will get out of the range of letters.

                    map_url += '&markers=color:blue%7Clabel:' + (String.fromCharCode(97 + i).toUpperCase()) + '%7C' + lats[i] + ',' + lngs[i]

                    markers.push({
                        position: {
                            lat: lats[i],
                            lng: lngs[i]
                        },
                        opacity: 1,
                        icon: 'https://firebasestorage.googleapis.com/v0/b/barnatasa5.appspot.com/o/app_assets%2Fsymbol_blank.png?alt=media&token=2a21b980-2dbb-4887-8fc3-3fba6d073252',
                        label: {
                            color: 'black',
                            text: (i + 1).toString()
                        },
                        unit_price: unit_prices[i],
                        url: urls[i],
                        address: addresses[i]
                    })

                }

                // console.log('prices: ')
                // console.log(prices)

                average_price = calcMean(unit_prices)

                average_price = Number(average_price.toFixed(2))

                let max = Math.max.apply(null, unit_prices)
                let min = Math.min.apply(null, unit_prices)
                let diff = max-min

                // calculating step for color scale formatting
                for (let i = 0; i < unit_prices.length; i++) {
                    let step = (unit_prices[i] - min ) / diff
                    // console.log('step: ')
                    // console.log(step)
                    markers[i]['step'] = step
                }

                // console.log('average_area_prices: ')
                // console.log(average_price)
            }

            api.get({path: query_path_start})
                .then((res) => {
                    console.log('!wey-start! res: ')
                    console.log(res)

                    collect_ads(data.lat, data.lng, data.startdate, data.limitdate, data.radius_km, res, result)
                    console.log('result: ')
                    console.log(result)

                    let sorted_result = _.sortBy(result, 'distance')

                    sorted_result_start = sorted_result

                    if(ad_year_limit !== ad_year_start){

                        api.get({path: query_path_limit})
                            .then((res) => {
                                console.log('!wey-limit! res: ')
                                console.log(res)

                                collect_ads(data.lat, data.lng, data.startdate, data.limitdate, data.radius_km, res, result)
                                console.log('result: ')
                                console.log(result)

                                let sorted_result_limit = _.sortBy(result, 'distance')



                                let final_sorted_result = sorted_result_start.concat(sorted_result_limit)

                                final_sorted_result = _.sortBy(final_sorted_result, 'distance')

                                commit(SET_MARKETSTUDY_MATCHED_ADS, final_sorted_result)

                                set_markers(final_sorted_result)

                                resolve({
                                    result: final_sorted_result,
                                    area_average_price: average_price,
                                    map_url: map_url,
                                    markers: markers
                                })


                            })

                    }else{
                        commit(SET_MARKETSTUDY_MATCHED_ADS, sorted_result)

                        set_markers(sorted_result)

                        resolve({
                            result: result,
                            area_average_price: average_price,
                            map_url: map_url,
                            markers: markers
                        })
                    }






                })

        })
    },
    SET_MARKETSTUDY_MATCHED_ADS: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_MATCHED_ADS, data)
    },

}

const mutations = {
    [SET_MARKETSTUDY_MATCHED_ADS] (state, data) {
        state.matched_ads = check_undefined(data)
    }
}

const getters = {
    marketstudy_matched_ads: state => {
        return state.matched_ads
    }
}

function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/marketstudy/marketstudy_ads.js